export default __webpack_public_path__ + "static/media/z-Connect - Payments.75332b63.pdf";